import React from "react";
import PropTypes from "prop-types";

import Button from "../Buttons";
import Typography from "../Typography";

import { StyledModal, StyledContentModal, StyledBodyModal } from "./Modal.styles";

const Modal = (props) => {
  const { show, icon, text, onclick, date, showLast } = props;
  return (
    <StyledModal show={show}>
      <StyledContentModal>
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-800 opacity-75" />
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>
        <StyledBodyModal>
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 sm:mx-0 sm:h-10 sm:w-10">
                <img src={icon} alt="Warning" className="" />
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <Typography variant="h3" className="font-medium">
                  {text}
                </Typography>
                <div className="mt-2 flex justify-center">
                  <Typography variant="h6" className="text-red-600 pr-1 ">
                    {showLast && " *Última Redención:"}
                  </Typography>
                  <Typography variant="h6" className="text-black">
                    {date}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <Button
              className="border-none py-2 uppercase mx-0 "
              label="Ver mis cupones"
              size="full"
              primary
              onClick={onclick}
            />
          </div>
        </StyledBodyModal>
      </StyledContentModal>
    </StyledModal>
  );
};
Modal.propTypes = {
  /**
   * Do you want to show the modal?
   */
  show: PropTypes.bool.isRequired,
  /**
   * Include an icon in the center of modal
   */
  icon: PropTypes.string,
  /**
   * Main text of modal
   */
  text: PropTypes.string,
  /**
   * Date the last redemption
   */
  date: PropTypes.string,
  /**
   * Optional click handler
   */
  onclick: PropTypes.func,

  showLast: PropTypes.bool,
};

Modal.defaultProps = {
  show: false,
  icon: null,
  text: "",
  date: "",
  onclick: () => {},
  showLast: true,
};

export default Modal;
